export const sliderConstants = {
    GETALL_REQUEST: 'SLIDER_GETALL_REQUEST',
    GETALL_SUCCESS: 'SLIDER_GETALL_SUCCESS',
    GETALL_FAILURE: 'SLIDER_GETALL_FAILURE',

    DELETE_REQUEST: 'SLIDER_DELETE_REQUEST',
    DELETE_SUCCESS: 'SLIDER_DELETE_SUCCESS',
    DELETE_FAILURE: 'SLIDER_DELETE_FAILURE'
};
